import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Modal, CloseButton } from "react-bootstrap";
import '../styles/InfoAbout.css';

export default function InfoAbout(){
    const navigate = useNavigate();    

    return (
        <section>
            <Button variant="outline-secondary" onClick={() => {navigate(-1)}} title='Go back to dashboard'>
                Go Back
            </Button>

            <article className='body-about'>
                <pre> 
                  DocuQuest is an app designed for requestors and 
                  employees of the Registrar's Office at Southwestern University PHINMA. 
                </pre>                

                <pre> 
                  The name is a combination of "Document" and "Request",
                  which accurately portrays the use of this
                  online system. 
                </pre>

                <pre>
                  DocuQuest is intented to make requesting for documents fast and easy 
                  by providing a platform which is accessible on the internet.
                </pre>

                <div className="spacer"></div>
                <pre>
                  It was developed by a 3-man team from BSIT-4-D1
                  and deployed in the School Year 2024-2025.
                </pre>

                <div className="spacer"></div>
                <pre>
                  If you have any questions or feedback about this system,
                  you can contact the registrar's office at
                </pre>

                <pre>
                  <i>registrar.swu@phinmaed.com</i>
                </pre>

                <div className="spacer"></div>
                <sub>
                  <i>Copyright © 2025 Southwestern University PHINMA All Rights Reserved</i>
                </sub>
            </article>
        </section>    
    )
}